import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="seller-profile-form"
export default class extends Controller {
  static targets = [
    "form",
    "submitButton",
    "disclosureConsent",
    "soleProprietorInput",
    "corporationsInput",
    "soleProprietorRadio",
    "corporationsRadio",
    "cancelPolicyTextarea",
  ];

  static values = {
    templateText: {
      type: String,
      default:
        "サービスに関して、依頼者のご都合によるキャンセル・返金は一切受け付けません。\n出品者の責に帰すべき事由により、サービスの提供が困難となった場合、 または成果物に重大な瑕疵がある場合には、出品者の責任にて返金対応を行います。",
    },
  };

  connect() {
    this.setupPageTransitionAlert();
    this.toggleBusinessTypeInputs();
  }

  /**
   * キャンセル・返金テキストエリアにテンプレートを挿入する
   */
  insertTemplate() {
    if (!this.hasCancelPolicyTextareaTarget) return;

    const inputText = this.cancelPolicyTextareaTarget.value;
    this.cancelPolicyTextareaTarget.value = inputText + this.templateTextValue;
  }

  /**
   * フォーム入力中にページ遷移しようとするとアラートを表示する
   */
  setupPageTransitionAlert() {
    if (!this.hasFormTarget) return;

    this.changeFlag = false;

    this.formTarget.addEventListener("change", () => {
      this.changeFlag = true;
    });

    // フォーム送信時はアラートを表示しない
    this.formTarget.addEventListener("submit", () => {
      this.changeFlag = false;
    });

    window.addEventListener("beforeunload", (event) => {
      if (this.changeFlag) {
        event.preventDefault();
        event.returnValue =
          "ページを移動しようとしています。\n入力した内容が失われますがよろしいですか？";
        return event.returnValue;
      }
    });
  }

  /**
   * フォーム送信時の処理（二重送信の防止）
   */
  handleSubmit() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.value = "送信中...";
    }
  }

  /**
   * 情報開示の同意チェックボックスによるsubmitボタンの活性/非活性を制御
   */
  toggleSubmitButton() {
    if (!this.hasDisclosureConsentTarget || !this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = !this.disclosureConsentTarget.checked;
  }

  /**
   * 個人事業主/法人選択による入力欄の表示切り替え
   */
  toggleBusinessTypeInputs() {
    if (!this.hasSoleProprietorRadioTarget || !this.hasCorporationsRadioTarget)
      return;

    if (this.soleProprietorRadioTarget.checked) {
      if (this.hasSoleProprietorInputTarget)
        this.soleProprietorInputTarget.style.display = "block";
      if (this.hasCorporationsInputTarget)
        this.corporationsInputTarget.style.display = "none";
    } else if (this.corporationsRadioTarget.checked) {
      if (this.hasSoleProprietorInputTarget)
        this.soleProprietorInputTarget.style.display = "none";
      if (this.hasCorporationsInputTarget)
        this.corporationsInputTarget.style.display = "block";
    } else {
      // 未選択の場合は両方非表示
      if (this.hasSoleProprietorInputTarget)
        this.soleProprietorInputTarget.style.display = "none";
      if (this.hasCorporationsInputTarget)
        this.corporationsInputTarget.style.display = "none";
    }
  }

  /**
   * ページ表示時（ブラウザバック含む）のリセット処理
   */
  resetOnPageShow() {
    // 同意チェックボックスを外す
    if (this.hasDisclosureConsentTarget) {
      this.disclosureConsentTarget.checked = false;
    }

    // 保存ボタンを無効化
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
    }
  }
}
